import React, { useState, useEffect } from "react";
import {
  Grid,
  Select,
  MenuItem,
  OutlinedInput,
  CircularProgress,
  InputLabel,
  FormControl
} from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import {
  ResponsiveContainer,
  /*Line,
  Area,
  ComposedChart,*/
  YAxis,
  XAxis,
  Tooltip,
  Legend,
  Bar,
  BarChart
} from "recharts";


// components
import PageTitle from "../../components/PageTitle";
import { Typography } from "../../components/Wrappers";
import LastYearCheck from "../../components/LastYearCheck/LastYearCheck";
import ApprovedLimitReminder from "../../components/ApprovedLimitReminder/ApprovedLimitReminder";
import ttAPI from '../../api/ttAPI';
import { useUserState } from "../../context/UserContext";

// styles
import useStyles from "./styles";
import Widget from "../../components/Widget";

import './chart.css'

export default function Dashboard(props) {
  var { user_name, fakeLogin } = useUserState();
  var classes = useStyles();
  var theme = useTheme();

  // local
  var [retestPredictionsChartRegionState, setRetestPredictionsChartRegionState] = useState(0);
  var [retestPredictionsChartMonthState, setRetestPredictionsChartMonthState] = useState(6); // 6, 3, 1 month
  var [retestPredictionsChartPeriod, setRetestPredictionsChartPeriod] = useState(0); // monthly 0, weekly 1
  var [retestPredictionsMonthly, setRetestPredictionsMonthly] = useState([]);
  var [retestPredictionsWeekly, setRetestPredictionsWeekly] = useState([]);
  //var [isMonthly, setIsMonthly] = useState([]);
  const colours = ['#EF5350','#EC407A','#AB47BC','#7E57C2','#5C6BC0','#42A5F5',
                   '#29B6F6','#26C6DA','#26A69A','#66BB6A','#9CCC65','#D4E157',
                   '#FFEE58','#FFCA28','#FFCA28','#FFA726','#FF7043','#8D6E63',
                   '#BDBDBD','#78909C','#E57373','#F06292','#BA68C8','#9575CD',
                   '#7986CB','#64B5F6','#4FC3F7','#4DD0E1','#4DB6AC','#81C784',
                   '#AED581','#DCE775','#FFF176','#FFD54F','#FFB74D','#FF8A65',
                   '#A1887F','#E0E0E0','#90A4AE'];
  const months = ['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];


const retestPredictionsMonthlyData = React.useMemo(() => {
  var resultArray = [];
  var iMax = 0;
  for (let i = 0; i < retestPredictionsMonthly.length; i++) {
      if (retestPredictionsMonthly[i].data !== undefined && retestPredictionsMonthly[i].data.length > iMax) {
          iMax = retestPredictionsMonthly[i].data.length;
      }
  }

  for (let i = 0; i < iMax; i++) {
      var lineData = {};
      retestPredictionsMonthly.map((retestPredictionMonthly,index) => {
        if(retestPredictionMonthly.data !== undefined &&  retestPredictionMonthly.data.length > i) {
          if (index === 0) {
              lineData.month_starting = retestPredictionMonthly.data[i].month_starting;
              lineData[retestPredictionMonthly.data[i].id] = retestPredictionMonthly.data[i].retests;
          }
          else {
            if (lineData.month_starting === retestPredictionMonthly.data[i].month_starting) {
                lineData[retestPredictionMonthly.data[i].id] = retestPredictionMonthly.data[i].retests;
            }
          }
        }
      });
      resultArray.push(lineData);
  }
  return resultArray;
}, [retestPredictionsMonthly]);

const retestPredictionsWeeklyData = React.useMemo(() => {
  var resultArray = [];
  var iMax = 0;
  for (let i = 0; i < retestPredictionsWeekly.length; i++) {
      if (retestPredictionsWeekly[i].data !== undefined &&  retestPredictionsWeekly[i].data.length > iMax) {
          iMax = retestPredictionsWeekly[i].data.length;
      }
  }

  for (let i = 0; i < iMax; i++) {
      var lineData = {};
      retestPredictionsWeekly.map((retestPredictionWeekly,index) => {
        if(retestPredictionWeekly.data !== undefined && retestPredictionWeekly.data.length > i) {
          if (index === 0) {
              lineData.week_starting = retestPredictionWeekly.data[i].week_starting;
              lineData[retestPredictionWeekly.data[i].id] = retestPredictionWeekly.data[i].retests;
          }
          else {
            if (lineData.week_starting === retestPredictionWeekly.data[i].week_starting) {
                lineData[retestPredictionWeekly.data[i].id] = retestPredictionWeekly.data[i].retests;
            }
          }
        }
      });
      resultArray.push(lineData);
  }
  return resultArray;
}, [retestPredictionsWeekly]);

const regions = React.useMemo(() => {
    var results = [];

    if (retestPredictionsChartPeriod == 0) {
        retestPredictionsMonthly.map((retestPredictionMonthly,index) => {
          results.push({id: retestPredictionMonthly.id, name: retestPredictionMonthly.name});
        });
    }
    else {
        retestPredictionsWeekly.map((retestPredictionWeekly,index) => {
          results.push({id: retestPredictionWeekly.id, name: retestPredictionWeekly.name});
        });
    }
  return results;
}, [retestPredictionsMonthly, retestPredictionsWeekly]);

const retestPredictionsDataByMonth = React.useMemo(() => {
    if (retestPredictionsChartMonthState == 6) {
        return retestPredictionsMonthlyData;
    }

    var date = new Date();
    date.setMonth(date.getMonth() + parseInt(retestPredictionsChartMonthState));
    return retestPredictionsMonthlyData.filter(rpd => new Date(rpd.month_starting) <= date);
}, [retestPredictionsChartMonthState]);

const retestPredictionsDataByWeek = React.useMemo(() => {
    if (retestPredictionsChartMonthState == 6) {
        return retestPredictionsWeeklyData;
    }

    var date = new Date();
    date.setMonth(date.getMonth() + parseInt(retestPredictionsChartMonthState));
    return retestPredictionsWeeklyData.filter(rpd => new Date(rpd.week_starting) <= date);
}, [retestPredictionsChartMonthState]);


  useEffect(() => {
     let mounted = true;
     const fetchData = async() => {
       const response = await ttAPI.getRetestPredictions(true);
       if(mounted){
          setRetestPredictionsMonthly(response);
       }
     };
     const fetchWeeklyData = async() => {
       const response = await ttAPI.getRetestPredictions(false);
       if(mounted){
          setRetestPredictionsWeekly(response);
       }
     };
     fetchData();
     fetchWeeklyData();

     return () => mounted = false;

  }, []);


  if (fakeLogin) {
    return (<><CircularProgress size={26}/></>);
  }

  return (user_name && retestPredictionsMonthly.length > 0 && regions !== undefined && regions.length > 0 &&
    <>
        <PageTitle title="Dashboard"/>
        <Grid container spacing={2}>
        <Grid item xs={12}>
          <Widget
            bodyClass={classes.mainChartBody}
            header={
              <div className={classes.mainChartHeader}>
                <Typography
                  variant="h6"
                  color="text"
                  weight={"medium"}
                  colorBrightness="secondary"
                >
                  Retest Report
                </Typography>

                <div className={classes.filters}>
                    <FormControl className={classes.formControl}>
                      <InputLabel>Region</InputLabel>
                      <Select
                        value={retestPredictionsChartRegionState}
                        onChange={e => setRetestPredictionsChartRegionState(e.target.value)}
                        input={
                          <OutlinedInput
                            labelWidth={0}
                            classes={{
                              notchedOutline: classes.mainChartSelectRoot,
                              input: classes.mainChartSelect
                            }}
                          />
                        }
                        autoWidth
                        className={classes.filter}
                      >
                        <MenuItem value="0">ALL</MenuItem>
                        {regions.map((value) => {
                            return (
                                <MenuItem key={value.id} value={value.id}>{value.name}</MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>

                    <FormControl className={classes.formControl}>
                      <InputLabel>Filter by</InputLabel>
                      <Select
                        value={retestPredictionsChartMonthState}
                        onChange={e => setRetestPredictionsChartMonthState(e.target.value)}
                        input={
                          <OutlinedInput
                            labelWidth={0}
                            classes={{
                              notchedOutline: classes.mainChartSelectRoot,
                              input: classes.mainChartSelect
                            }}
                          />
                        }
                        autoWidth
                        className={classes.filter}
                      >
                        <MenuItem value="6">6 Months</MenuItem>
                        <MenuItem value="3">3 Months</MenuItem>
                        <MenuItem value="1">1 Month</MenuItem>

                      </Select>
                    </FormControl>

                    <FormControl className={classes.formControl}>
                    <InputLabel>View as</InputLabel>
                      <Select
                        value={retestPredictionsChartPeriod}
                        onChange={e => setRetestPredictionsChartPeriod(e.target.value)}
                        input={
                          <OutlinedInput
                            labelWidth={0}
                            classes={{
                              notchedOutline: classes.mainChartSelectRoot,
                              input: classes.mainChartSelect
                            }}
                          />
                        }
                        autoWidth
                        className={classes.filter}
                      >
                        <MenuItem value="0">Monthly</MenuItem>
                        <MenuItem value="1">Weekly</MenuItem>

                      </Select>
                    </FormControl>
                  </div>
              </div>
            }
          >


          <ResponsiveContainer width="100%" minWidth={500} height={350}>
            <BarChart
              margin={{ top: 5, right: 30, left: 20, bottom: 100 }}
              data={retestPredictionsChartMonthState == 6 ? (retestPredictionsChartPeriod == 0 ? retestPredictionsMonthlyData : retestPredictionsWeeklyData)  : (retestPredictionsChartPeriod == 0 ? retestPredictionsDataByMonth : retestPredictionsDataByWeek)}
            >
                <XAxis dataKey={retestPredictionsChartPeriod == 0 ? 'month_starting' : 'week_starting'}
                      tick={{
                        fill: theme.palette.text.hint,
                        fontSize: 14
                      }}
                      stroke={theme.palette.text.hint + "80"}
                      tickLine={false}
                      tickFormatter={(tickItem) => {
                        var tis = tickItem.split('-');
                        if (retestPredictionsChartPeriod == 0) {
                          return months[parseInt(tis[1]) - 1];
                        }

                        return `${tis[1]}-${tis[2]}`;
                      }}
                      angle={-45} textAnchor="end"
                      />
                <YAxis
                        tick={{
                          fill: theme.palette.text.hint,
                          fontSize: 14
                        }}
                        stroke={theme.palette.text.hint + "80"}
                        tickLine={false}/>
                        <Tooltip />
                        <Legend wrapperStyle={{bottom: 60}}/>

                    />

                      {regions.map((value) => {
                            return (

                                <Bar
                                  hide={retestPredictionsChartRegionState > 0 ? retestPredictionsChartRegionState !== value.id : false}
                                  key={value.id}
                                  name={value.name}
                                  type="natural"
                                  dataKey={value.id}
                                  barSize={retestPredictionsChartPeriod == 0 ? 100 : 40}
                                  fill={colours[value.id]}
                                  stackId="a"
                                />
                          );
                        })}
            </BarChart>
          </ResponsiveContainer>
          </Widget>
          </Grid>

          <Grid item xs={12}>
            <ApprovedLimitReminder />
          </Grid>

          <Grid item xs={12}>
            <LastYearCheck />
          </Grid>
          </Grid>
    </>
  );
}
